//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { eventData } from '@/utils/events'

export default {
    data() {
        return {
            eventData,
            publishComponents: [],
        }
    },
    computed: {
        eventKeys() {
            // console.log('eventKeys')
            // console.log(this.$store.state.curComponent)
            // console.log(this.$store.state.componentData)
            if (this.$store.state.curComponent) {
                if(this.$store.state.curComponent.component == 'v-button') {
                    this.$store.state.componentData.forEach(component => {
                        if(component.component == 'v-input' && this.publishComponents.indexOf(component.id) == -1) {
                            this.publishComponents.push(component.id)
                        }
                    })
                    // console.log(this.publishComponents)
                    // console.log(this.$store.state.curComponent.events.publishComponents)
                    // 下拉框选中里删除已被删除的组件
                    this.$store.state.curComponent.events.publishComponents = 
                    this.$store.state.curComponent.events.publishComponents.filter(item => this.publishComponents.includes(item))
                    // console.log(this.$store.state.curComponent.events.publishComponents)
                }
                const curComponentEventKeys = Object.keys(this.$store.state.curComponent.events)
                return this.eventData.filter(item => curComponentEventKeys.includes(item.key))
            }
            return []
        },
        curComponent() {
            return this.$store.state.curComponent
        },
    }
}
